/* ============================================================
   Kaynaturalz — cart reservation countdown
   Shows a rolling "Your cart is reserved for MM:SS" timer in the
   cart drawer footer, above the Checkout button. Pure front-end
   urgency: the deadline is stored per-session so it survives page
   navigation, and it never truly expires — when it hits zero it
   quietly restarts a fresh reservation window.
   ============================================================ */
(function () {
  "use strict";

  var KEY = "kn_cart_reserve_until";
  var WINDOW_MS = 10 * 60 * 1000; // 10 minute reservation window
  var FINAL_MS = 60 * 1000;       // last minute -> emphasized style

  function now() { return new Date().getTime(); }

  function getDeadline() {
    var stored = null;
    try { stored = sessionStorage.getItem(KEY); } catch (e) {}
    var t = stored ? parseInt(stored, 10) : 0;
    if (!t || isNaN(t) || t <= now()) {
      t = now() + WINDOW_MS;
      try { sessionStorage.setItem(KEY, String(t)); } catch (e) {}
    }
    return t;
  }

  function fmt(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000);
    var m = Math.floor(s / 60);
    var r = s % 60;
    return m + ":" + (r < 10 ? "0" : "") + r;
  }

  document.addEventListener("DOMContentLoaded", function () {
    var box = document.getElementById("cartTimer");
    var clock = document.getElementById("cartTimerClock");
    if (!box || !clock) return;

    var deadline = getDeadline();

    function paint() {
      var rem = deadline - now();
      if (rem <= 0) {
        // Reservation lapsed — start a fresh window so it never dead-ends.
        deadline = now() + WINDOW_MS;
        try { sessionStorage.setItem(KEY, String(deadline)); } catch (e) {}
        rem = WINDOW_MS;
      }
      clock.textContent = fmt(rem);
      box.classList.toggle("is-final", rem <= FINAL_MS);
    }

    paint();
    setInterval(paint, 1000);
  });
})();